import React, { forwardRef } from 'react';
import cn from 'classnames';
import { BUTTON_SIZES, BUTTON_SIZES_WITH_ICON } from '../classnames';
import parseClassnames from '../../helpers/parseClassnames';
import { getDefaultIconValues, IconItemType } from '../helpers';
import { InverseButtonProps } from './types';

const InverseButton = forwardRef<any, InverseButtonProps>(
  (
    {
      children,
      label,
      size = 'm',
      as,
      white,
      gray,
      darkMode,
      full,
      leftIcon: leftIconProp,
      rightIcon: rightIconProp,
      href,
      className = '',
      disabled,
      ...other
    },
    ref,
  ) => {
    const leftIcon: IconItemType = getDefaultIconValues(
      leftIconProp,
      size === 'xs' ? 16 : 24,
    );
    const rightIcon: IconItemType = getDefaultIconValues(
      rightIconProp,
      size === 'xs' ? 16 : 24,
    );
    let Tag: keyof JSX.IntrinsicElements = 'button';

    if (as) {
      Tag = as;
    } else if (href) {
      Tag = 'a';
    }

    let buttonTypeClassNames = darkMode
      ? 'button-inverse-dark'
      : 'button-inverse';

    if (gray) {
      buttonTypeClassNames = 'button-inverse-gray';
    }
    if (white) {
      buttonTypeClassNames = 'button-inverse-white';
    }

    return (
      <Tag
        className={parseClassnames(
          className,
          cn(
            leftIcon.component || rightIcon.component
              ? BUTTON_SIZES_WITH_ICON[size]
              : BUTTON_SIZES[size],
            buttonTypeClassNames,
            {
              'w-full': full,
              [darkMode
                ? 'button-dark border-gray-dark'
                : 'button-light border-gray-main']: disabled,
            },
          ),
        )}
        href={href}
        ref={ref}
        disabled={disabled}
        {...other}
      >
        {leftIcon.component && (
          <leftIcon.component
            size={leftIcon.size}
            className={cn(
              {
                'fill-current': leftIcon.hasFill,
                'stroke-current': leftIcon.hasStroke,
                'mr-8': label || children,
              },
              'flex-shrink-0',
            )}
            ignoreColor
          />
        )}
        {label || children}
        {rightIcon.component && (
          <rightIcon.component
            size={rightIcon.size}
            className={cn(
              {
                'fill-current': rightIcon.hasFill,
                'stroke-current': rightIcon.hasStroke,
                'ml-8': label || children,
              },
              'flex-shrink-0',
            )}
            ignoreColor
          />
        )}
      </Tag>
    );
  },
);

export default InverseButton;
